import { Loader2, Eye, EyeOff, Check, X } from 'lucide-react';

export const Icons = {
  spinner: Loader2,
  eye: Eye,
  eyeOff: EyeOff,
  check: Check,
  x: X,
};
